import store from '@/store'

export default [
  {
    path: '/student-enrollments',
    name: 'student-enrollment',
    meta: { requiresAuth: true },
    component: () => import('@/pages/student-enrollment/index.vue')
  },
  {
    path: '/student-enrollments/create',
    name: 'student-enrollment-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/student-enrollment/create.vue')
  }
]
